'use strict';


var Emitter = require('cjs-emitter'),
    api = require('../../../index'),
    collector = new Emitter();


function removeProvider ( index ) {
    console.log('remove provider at index: ' + index);
    collector.providers[index] = null;
    // collector.rows.splice(0);
}

collector.rows = [];
collector.providers = [];
collector.imagePath = null;


collector.load = function ( config, onDataReady ) {
    var loadCounter, totalLoads, dependencies,
        offset, providerMap, originalDataReady;

    if ( DEVELOP ) {
        originalDataReady = onDataReady;
        onDataReady = function () {
            try {
                originalDataReady();
            } catch ( error ) {
                console.log('error in ' + __filename + ':31 msg:' + error);
                if ( error.stack ) {
                    console.log('stack: ' + error.stack);
                }
            }
        };
    }

    // console.log('load called');
    // console.log('offset ' + config.offset);
    // console.log('count ' + config.count);
    // console.log('rows ' + collector.rows.length);
    // console.log('need LOAD???: ' + (config.offset + config.count > collector.rows.length));
    if ( config.offset + config.count > collector.rows.length ) {
        // requested query required new data
        dependencies = {};
        providerMap = {};
        loadCounter = 0;
        totalLoads = 0;

        offset = config.offset;
        // console.log('providers ' + collector.providers.length);
        while ( offset <= config.offset + config.count && offset < collector.providers.length ) {
            // console.log('offset at loop start: ' + offset);

            if ( !collector.rows[offset] ) {
                // console.log('add to dependencies ' + collector.providers[offset].packageName);
                dependencies[collector.providers[offset].packageName] = collector.providers[offset].version;
                // console.log('no row in offset: ' + offset);
                providerMap[collector.providers[offset].packageName] = offset;
                // application = collector.providers[offset].application;
                collector.rows.push([]);
                ++totalLoads;
            }

            ++offset;
            // console.log('offset at loop end: ' + offset);
            // console.log('totalLoads ' + totalLoads);
        }

        // console.log('dependencies: ' + JSON.stringify(dependencies));

        core.dependencyManager.load({
            dependencies: dependencies,
            dependencyReady: function ( dependencyError, plugin  ) {
                var packageConfig = core.packageMap[plugin.packageName];

                // console.log('pkg ' + plugin.packageName);
                // console.log('return? ' + (providerMap[plugin.packageName] === null));

                if ( !packageConfig.contentBoardApi ) {
                    // console.log('pkg ' + plugin.packageName  + ' dont have contentBoardApi property');

                    return;
                }

                if ( typeof plugin.instance.onContentBoardInit !== 'function' ) {
                    // console.log('pkg ' + plugin.packageName  + ' dont have onContentBoardInit');
                    return;
                }

                if ( providerMap[plugin.packageName] === null ) {
                    // console.log('repeated dependencyReady call');
                    return;
                }

                // console.log('dependencyReady, error: ' + dependencyError);

                if ( dependencyError ) {
                    removeProvider(providerMap[plugin.packageName]);
                    ++loadCounter;

                    if ( loadCounter === totalLoads ) {
                        onDataReady();
                        loadCounter = totalLoads = dependencies = null;
                    }
                    // remove plugin from providers
                } else {
                    // console.log(JSON.stringify(Object.keys(plugin.instance)));
                    plugin.instance.onContentBoardInit({
                        api: api,
                        storage: plugin.storage,
                        path: plugin.path
                    }, function ( error, result ) {
                        var app = collector.providers[providerMap[plugin.packageName]].application;

                        // console.log('onContentBoardInit callback called for ' + plugin.packageName);
                        if ( error || !result ) {
                            removeProvider(providerMap[plugin.packageName]);
                            ++loadCounter;

                            if ( loadCounter === totalLoads ) {
                                onDataReady();
                                loadCounter = totalLoads = dependencies = null;
                            }

                            return;
                        }

                        if ( result.data ) {
                            console.log(result.data.length > 0);
                            if ( result.data.length > 0 ) {
                                result.data.forEach(function ( item ) {
                                    if ( !item.data.colors ) {
                                        item.data.colors = {
                                            background: app.colors.splashBackground,
                                            foreground: app.colors.splashFont
                                        };
                                    }

                                    if ( item.runApp ) {
                                        item.onClick = function () {
                                            require('../utils/run.app')(app);
                                        };
                                    }
                                    // console.log('!!!!!!!!!!!!!push ' + JSON.stringify(item));
                                    collector.rows[providerMap[plugin.packageName]].push(item);
                                });
                            } else {
                                console.log('no data');
                                console.log(providerMap[plugin.packageName]);
                            }
                        }

                        collector.providers[providerMap[plugin.packageName]].instance = result.provider;
                        collector.providers[providerMap[plugin.packageName]].colors = {
                            background: app.colors.splashBackground,
                            foreground: app.colors.splashFont
                        };

                        providerMap[plugin.packageName] = null;

                        ++loadCounter;
                        console.log('loadCounter: ' + loadCounter);
                        console.log('totalLoads: ' + totalLoads);
                        console.log('collector.rows:' + collector.rows.length);

                        if ( loadCounter === totalLoads ) {
                            try {
                                onDataReady();
                            } catch (error) {
                                console.log('error in ' + __filename + ':141 ' + error);
                                if ( error.stack ) {
                                    console.log('stack: ' + error.stack);
                                }
                            }

                            loadCounter = totalLoads = dependencies = null;
                        }
                    });
                }
            }
        });
    } else {
        try {
            onDataReady();
        } catch ( error ) {
            console.log('error in ' + __filename + ':155' + error);

            if ( error.stack ) {
                console.log('stack: ' + error.stack);
            }
        }
    }
};

module.exports = collector;
